import { useMemo } from 'react';

import {
  useSuspenseGetAccounts,
  useSuspenseGetIwocapayPaymentCaptured,
  useSuspenseGetIwocapayPaymentLater,
} from '../../../api/lending/lapiHooks.suspense';
import {
  getCancelledPlans,
  getCapturedPlans,
  getEndedPayments,
  getOngoingPaymentPlans,
  getPaymentPlans,
} from '../Dashboard.helpers';

export function usePaymentPlansData() {
  const { accounts } = useSuspenseGetAccounts();
  const { buyerPayLinks } = useSuspenseGetIwocapayPaymentLater();
  const { capturedPayments } = useSuspenseGetIwocapayPaymentCaptured();

  return useMemo(() => {
    if (!accounts?.accounts || !buyerPayLinks) {
      return {
        ongoingPaymentPlans: [],
        capturedPlans: [],
        cancelledPayments: [],
        endedPayments: [],
      };
    }

    const capturedPaymentsData = capturedPayments || [];
    const capturedPlansList = getCapturedPlans(
      capturedPaymentsData,
      buyerPayLinks,
    );
    const paymentPlans = getPaymentPlans(accounts.accounts, buyerPayLinks);
    const ongoingPaymentPlans = getOngoingPaymentPlans(paymentPlans);
    const cancelledPayments = getCancelledPlans(
      capturedPaymentsData,
      buyerPayLinks,
    );
    const endedPayments = getEndedPayments(accounts.accounts, buyerPayLinks);

    return {
      ongoingPaymentPlans,
      capturedPlans: capturedPlansList,
      cancelledPayments,
      endedPayments,
    };
  }, [accounts, buyerPayLinks, capturedPayments]);
}
